export const statusHeaderTranslationJP = {
  Status_Header: {
    login_information: 'ログイン情報',
    department_name: '部門名',
    employee_name: '社員名',
    employee_code: '社員コード',
    company_name: '会社名',
    job_name: '職務',
    return: '戻る',
    logout: 'ログアウト',
    login_time: 'ログイン日時',

    //menu
    business_type: '業態共通',
    bar_guide_list: 'バー案内一覧',
    group_store: '店舗関連',
    menu_store_setting: '店舗設定一覧',
    group_counter_pattern: 'レジパターン関連',
    menu_display_setting_by_counter_pattern: 'レジパターン別表示設定',
    group_sale_type: '販売タイプ関連',
    menu_sale_type_list: '販売タイプ一覧',
    eating_way_list: '食べ方一覧',
    group_menu_book: 'メニューブック関連',
    menu_menu_book_list: 'メニューブック一覧',
    menu_genre_list: 'ジャンル一覧',
    menu_subgenre_list: 'サブジャンル一覧',
    menu_menu_list: 'メニュー一覧',
    subtitle_menu_list: 'サブタイトルメニュー一覧',
    menu_group_option_list: 'サブメニューグループ一覧',
    group_delivery: '配信関連',
    menu_delivery_setting: '配信設定／状況一覧',
    group_data: 'データ取込',
    menu_import_register_data: 'レジデータ取込',
    display_control_group: '表示制御グループ',
    overlay_function: '任意オーバーレイ',
    daily_menu: '日替わりメニュー',
    course_order_limit: 'コース注文数制限設定',
    service_menu: 'サービス編集',
    video_function: '動画再生編集',
    shabu_sukiyaki: 'しゃぶしゃぶ／すき焼き定食設定',
    menu_serving_time: '提供タイミング一覧',
  },
};
